<template>
  <transition name="slide">
    <el-dialog
      :class="['modal-topology', 'sliding', 'no-footer', 'automap-object']"
      :style="{maxWidth: '450px'}"
      modal-class="modal-topology sliding"
      :visible.sync="visible"
      :close-on-click-modal="false"
      :modal-append-to-body="true"
      :append-to-body="true"
      :modal="false"
      top="0"
      :width="popupWidth"
      @open="opened"
      @close="closed"
      >
      <!-- 타이틀 영역 -->
      <div class="title-wrapper" slot="title">
        <!-- 회선 -->
        <div class="title-content content-between" v-if="isLan">
          <w-managed-object-title
            v-if="showSrcObj"
            :class="lanPatitionCls"
            :title="obj.src.objName"
            :sub-title="`${obj.src.parentName}(${obj.src.ipaddress})`"
            :icon-class="getObjTypeIconClass('src')"
            :show-state="showOperState"
            :state="operStateValue.value"
            :clickable-title="true"
            @title-click="clickDetail('', 'src')"
          />
          <w-managed-object-title
            v-if="showDstObj"
            :class="lanPatitionCls"
            :title="obj.dst.objName"
            :sub-title="`${obj.dst.parentName}(${obj.dst.ipaddress})`"
            :icon-class="getObjTypeIconClass('dst')"
            :show-state="showOperState"
            :state="operStateValue.value"
            :clickable-title="true"
            @title-click="clickDetail('', 'dst')"
          />
        </div>
        <!-- 그외 대상 -->
        <div class="title-content" v-else>
          <w-managed-object-title
            :title="obj.objName"
            :sub-title="obj.ipaddress"
            :icon-class="getObjTypeIconClass('')"
            :show-state="showOperState"
            :state="operStateValue.value"
            :clickable-title="true"
            @title-click="clickDetail"
          />
        </div>
        <el-select class="interface-select title-tool" v-if="showViewSelectBox" v-model="selectedViewType" placeholder="데이터가 없습니다.">
          <el-option label="In" value="src" />
          <el-option label="Out" value="dst" />
          <el-option label="Both" value="partition" />
        </el-select>
      </div>
      <template v-if="isLan">
        <!-- 관리도구 -->
        <div class="manage-tool-wrapper">
          <div class="content-between">
            <w-manage-tool-shorten-set :class="lanPatitionCls" v-show="showSrcObj" :obj="obj.src" :is-obj="isSrcObj"/>
            <w-manage-tool-shorten-set :class="lanPatitionCls" v-show="showDstObj" :obj="obj.dst" :is-obj="isDstObj"/>
          </div>
        </div>
        <!-- 컨텐츠 -->
        <div class="content-between" style="height: 100%" v-loading="isLoading">
          <!-- 회선 -->
          <div v-show="showSrcObj" :class="['content-wrapper', 'tab-wrapper', 'origin', 'managed-object', lanPatitionCls]" style="padding: 5px 10px;">
            <el-tabs v-if="isSrcObj" v-model="activeSrcContent">
              <el-tab-pane label="장비정보" name="EXPAND">
                <el-scrollbar>
                  <w-managed-object-basic-info-view class="mr-b15" ref="basicSrcInfo" :object-info="obj.src" />
                  <w-managed-object-perf-info-view class="mr-b15" ref="perfSrcInfo" />
                  <w-common-event-info-view ref="eventSrcInfo" :is-map="true" :lan-type="'src'" :fit-height="true" :is-obj="true" :is-lan="isLan" @click-detail="clickDetail" />
                </el-scrollbar>
              </el-tab-pane>
              <el-tab-pane label="연결정보" name="BASIC">
                <el-scrollbar>
                  <w-automap-object-config-info-view class="mr-b25" ref="configSrcInfo" :object-info="obj.src" :object-type="'LAN'" :is-obj="isSrcObj"/>
                  <w-automap-object-connect-info-view  ref="connectSrcInfo" :object-info="obj.src" :object-type="'LAN'" :is-obj="isSrcObj" />
                </el-scrollbar>
              </el-tab-pane>
            </el-tabs>
            <div v-else class="no-tabs-wrapper">
              <el-scrollbar>
                <w-automap-object-config-info-view  class="mr-b25" ref="configSrcInfo" :object-info="obj.src" :object-type="'LAN'" :is-obj="isSrcObj"/>
                <w-automap-object-connect-info-view  ref="connectSrcInfo" :object-info="obj.src" :object-type="'LAN'" :is-obj="isSrcObj" />
              </el-scrollbar>
            </div>
          </div>
          <div v-show="showDstObj" :class="['content-wrapper', 'tab-wrapper', 'origin', 'automap-object', 'managed-object', lanPatitionCls]" style="padding: 5px 10px;">
            <el-tabs v-if="isDstObj" v-model="activeDstContent">
              <el-tab-pane label="장비정보" name="EXPAND">
                <el-scrollbar>
                  <w-managed-object-basic-info-view class="mr-b15" ref="basicDstInfo" :object-info="obj.dst" />
                  <w-managed-object-perf-info-view class="mr-b15" ref="perfDstInfo" />
                  <w-common-event-info-view ref="eventDstInfo" :is-map="true" :lan-type="'dst'" :is-obj="true" :fit-height="true" :is-lan="isLan" @click-detail="clickDetail" />
                </el-scrollbar>
              </el-tab-pane>
              <el-tab-pane label="연결정보" name="BASIC">
                <el-scrollbar>
                  <w-automap-object-config-info-view class="mr-b25" ref="configDstInfo" :object-info="obj.dst" :object-type="'LAN'" :is-obj="isDstObj"/>
                  <w-automap-object-connect-info-view  ref="connectDstInfo" :object-info="obj.dst" :object-type="'LAN'" :is-obj="isDstObj"/>
                </el-scrollbar>
              </el-tab-pane>
            </el-tabs>
            <div v-else class="no-tabs-wrapper">
              <el-scrollbar>
                <w-automap-object-config-info-view  class="mr-b25" ref="configDstInfo" :object-info="obj.dst" :object-type="'LAN'" :is-obj="isDstObj"/>
                <w-automap-object-connect-info-view ref="connectDstInfo" :object-info="obj.dst" :object-type="'LAN'" :is-obj="isDstObj"/>
              </el-scrollbar>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 관리도구 -->
        <div class="manage-tool-wrapper">
          <!-- 관리대상 (하위맵, 사용자정의 위젯 제외) -->
          <w-manage-tool-shorten-set ref="manageToolShortenSet" v-show="showManageToolsetToObject" :obj="obj" :is-obj="isObj"/>
        </div>
        <!-- 컨텐츠 -->
        <div :class="['content-wrapper', 'tab-wrapper', 'origin', 'automap-object', 'managed-object']" v-loading="isLoading" style="padding: 5px 10px;">
          <el-tabs v-if="isObj" v-model="activeContent">
            <el-tab-pane label="장비정보" name="EXPAND">
              <el-scrollbar>
                <w-managed-object-basic-info-view  class="mr-b15" ref="basicInfo" :object-info="obj" />
                <w-e2e-agent-combobox class="mr-b15" v-if="showAgentSelectBox" :agent-list="agentList" @change="changeAgent" />
                <w-managed-object-perf-info-view class="mr-b15" v-if="showPerfInfo" ref="perfInfo" />
                <w-common-event-info-view ref="eventInfo" :is-map="true" :is-obj="true" :fit-height="true" @click-detail="clickDetail" />
              </el-scrollbar>
            </el-tab-pane>
            <el-tab-pane label="연결정보" name="BASIC">
              <el-scrollbar>
                <w-automap-object-config-info-view class="mr-b25"  ref="configInfo" :object-info="obj" :object-type="'DEVICE'" :is-obj="isObj"/>
                <w-automap-object-connect-info-view  ref="connectInfo" :object-info="obj" :object-type="'DEVICE'" :is-obj="isObj"/>
              </el-scrollbar>
            </el-tab-pane>
          </el-tabs>
          <div v-else class="no-tabs-wrapper">
            <el-scrollbar>
              <w-automap-object-config-info-view  class="mr-b25" ref="configInfo" :object-info="obj" :object-type="'DEVICE'" :is-obj="isObj"/>
              <w-automap-object-connect-info-view   ref="connectInfo" :object-type="'DEVICE'" :object-info="obj" :is-obj="isObj"/>
            </el-scrollbar>
          </div>
          <!-- 그외 대상 -->
        </div>
      </template>
    </el-dialog>
  </transition>
</template>

<script>
import axios from 'axios';
import { isNil, isEmpty, capitalize, cloneDeep } from 'lodash';
import MapAPI from '@/api/topologymap/common';
import EventPredictSettingsAPI from '@/api/settings/common/event-predict-settings';
import { Q, MapInfo } from '@/views/topologymap/js/maps';
import Base from '@/mixins/topologymap/base';

import { OPER_STATE_RSC_LIST, PERF_RSC_LIST } from '@/constants/topologymap-major-info';
import { routePathByObjId } from '@/utils/router';
import { objtype } from '@/constants/objtype';
import { performanceNodeTabs } from '@/constants/performance';
import MapConst from '@/constants/topologymap';
import { getE2eAgentList, getObjTypeIconClass, isVisibleOperStateOfObj, isVisiblePerfInfo, isVisibleAgentCombobox, getObjStatusToBoolean } from '@/utils/obj-major-info';

import WManageToolShortenSet from '@/views/topologymap/components/major-info/components/ManageToolShortenSet';
import WManagedObjectTitle from '@/views/topologymap/components/major-info/ManagedObjectTitle';
import WManagedObjectBasicInfoView from '@/views/topologymap/components/major-info/ManagedObjectBasicInfoView';
import WAutomapObjectConfigInfoView from '@/views/topologymap/components/major-info/AutomapObjectConfigInfoView';
import WAutomapObjectConnectInfoView from '@/views/topologymap/components/major-info/AutomapObjectConnectInfoView';
import WOtherObjectBasicInfoView from '@/views/topologymap/components/major-info/OtherObjectBasicInfoView';
import WManagedObjectPerfInfoView from '@/views/topologymap/components/major-info/ManagedObjectPerfInfoView';
import WOtherObjectPerfInfoView from '@/views/topologymap/components/major-info/OtherObjectPerfInfoView';
import WE2eAgentCombobox from '@/views/topologymap/components/major-info/components/E2eAgentCombobox';
import WCommonEventInfoView from '@/views/topologymap/components/major-info/CommonEventInfoView';
import { menuDefine } from '@/constants/menu';
import { getIntervalDatetimeParams } from '@/utils/date';

export default {
  name: 'WAutoMapObjectMajorInfoPopup',
  mixins: [Base],
  components: {
    WManagedObjectBasicInfoView,
    WAutomapObjectConfigInfoView,
    WAutomapObjectConnectInfoView,
    WManagedObjectTitle,
    WOtherObjectBasicInfoView,
    WManagedObjectPerfInfoView,
    WOtherObjectPerfInfoView,
    WE2eAgentCombobox,
    WCommonEventInfoView,
    WManageToolShortenSet,
  },
  data() {
    return {
      isLoading: false,
      scheduleId: null,
      type: 'common',
      visible: false,
      activeTab: '',
      activeSrcContent: 'EXPAND',
      activeDstContent: 'EXPAND',
      activeContent: 'EXPAND',
      /**
       * 회선일경우 In/Out/Both에 따라 분할 여부
       * @type {Boolean}
       */
      isPartition: false,
      /**
       * 회선
       * @type {Boolean}
       */
      isLan: false,
      /**
       * 회선의 src, dsc중 하나만 있는 경우
       * @type {Boolean}
       */
      isSingleLan: false,
      isObj: true,
      isSrcObj: true,
      isDstObj: true,
      isRelationshipLan: false,
      /**
       * In/Out/Both 선택 값
       * @type {String}
       */
      selectedViewType: 'src',
      /**
       * 해당 팝업에서 표출하는 대상 정보
       * 회선일 경우 src, dst로 dept 깊어짐
       * @type {Object}
       */
      obj: {
      },
      /**
       * 운영상태 값
       * @type {Object}
       */
      operStateValue: {
      },
      /**
       * E2E에 대해 에이전트 정보 선택 콤보박스 값
       * @type {[type]}
       */
      selectedAgent: null,
      /**
       * E2E 대상에 연결된 에이전트 리스트
       * @type {Array}
       */
      agentList: [
        { objId: 0, objName: '-', agentId: 0 },
      ],
      /**
       * E2E에 대해 선택 된 에이전트 정보
       * @type {Object}
       */
      agentInfo: {
        transactionId: 0,
        transactionServiceId: 0,
        rscKey: '-',
      },
      /**
       * 하위맵 && 사용자정의위젯의 성능정보 조회 자원
       * @type {Array}
       */
      subMapChartRsc: [
        { rsctypeName: '', rscName: '' },
      ],
      /**
       * 관리대상의 성능정보 조회 자원
       * @type {Object}
       */
      PERF_RSC_LIST,
      /**
       * 운영상태 && 가동률 조회 자원
       * @type {Object}
       */
      OPER_STATE_RSC_LIST,
    };
  },
  computed: {
    /**
     * 가변적 팝업 너비 반환
     * 회선클릭 시 src, dst 모두 존재할 경우 출발지/목적지/분할로 볼 수 있도록 설정이 가능하므로 팝업 너비 가변적으로 반환해야함.
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    popupWidth() {
      return this.isPartition ? '900px' : '450px';
    },
    /**
     * 성능정보 표현 여부 (서비스는 성능정보 미제공)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    showPerfInfo() {
      return isVisiblePerfInfo(this.obj.objDefineId);
    },
    /**
     * agent 선택 콤보박스 표현 여부(E2E일 경우 agent 선택할 수 있는 콤보박스 제공)
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    showAgentSelectBox() {
      return isVisibleAgentCombobox(this.obj.objDefineId);
    },
    /**
     * 회선 클릭 시 src, dst 존재 여부에 따라 viewType을 지정할 수 있는 콤보박스 표현 여부
     * src, dst 모두 존재할 경우 출발지/목적지/분할로 볼 수 있도록 설정 가능
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    showViewSelectBox() {
      return (this.isLan && !this.isSingleLan);
    },
    /**
     * 회선을 클릭했을 경우 selectedViewType의 값에 따라 출발지 대상의 정보 표현 여부
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    showSrcObj() {
      return this.isLan && !isEmpty(this.obj.src) && (this.selectedViewType !== 'dst');
    },
    /**
     * 회선을 클릭했을 경우 selectedViewType의 값에 따라 도착지 대상의 정보 표현 여부
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    showDstObj() {
      return this.isLan && !isEmpty(this.obj.dst) && (this.selectedViewType !== 'src');
    },
    showManageToolsetToObject() {
      return !this.isConnectObjec;
    },
    showManageToolsetToLan() {
      return !this.isConnectObjec;
      // return !this.isRelationshipLan;
    },
    /**
     * 회선클릭 시 분할 여부에 따라 class 반환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    lanPatitionCls() {
      return (this.isPartition) ? 'partition-double' : 'partition-single';
    },
    /**
     * 운영상태 표현 여부
     * @return {[type]} [description]
     */
    showOperState() {
      let state = true;
      if (this.isLan) {
        state = false;
      } else if (!this.isObj) {
        state = false;
      } else {
        state = isVisibleOperStateOfObj(this.obj.objDefineId);
      }
      return state;
    },
    showDetail() {
      return (type) => {
        if (!isEmpty(type)) {
          return this[`is${capitalize(type)}Obj`];
        }
        return this.isObj;
      };
    },
    /**
     * objtype 별 아이콘 class 반환
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    getObjTypeIconClass() {
      return (type) => {
        let iconClass;
        const obj = (this.isLan) ? this.obj[type] : this.obj;
        if (!isEmpty(obj)) {
          iconClass = getObjTypeIconClass(obj.objManagetypeId, obj.objDefineId, obj.objtypeId);
        }
        if (isNil(iconClass)) {
          if (!this.isObj) {
            iconClass = 'fas fa-hdd'; // fas fa-digital-tachograph, fas fa-credit-card-front
          }
          if (this.isLan) {
            iconClass = 'fas fa-ethernet';
          }
        }
        return iconClass;
      };
    },
  },
  watch: {
    selectedViewType(type) {
      this.isPartition = (type === 'partition');
    },
    visible(val) {
      if (!val) {
        this.initData();
      }
    },
  },
  created() {
    this.$mapEventBus.$on(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, this.showAndHide);
  },
  beforeDestroy() {
    this.$mapEventBus.$off(MapConst.MAP_EVENTBUS.AUTOMAP_MAJOR_INFO, this.showAndHide);
  },
  methods: {
    getLanObject(type, lan) {
      return {
        objId: lan[`${type}ObjId`],
        objName: lan[`${type}ObjName`],
        parentName: lan[`${type}ParentName`],
        ipaddress: lan[`${type}Ipaddress`],
        objDefineId: 'NETINTERFACE',
        objManagetypeId: 'NMS',
        elementId: lan[`${type}ElementId`],
      };
    },
    getAutomapLanObject(type, lan, local, remote) {
      let parentName = '';

      if (isEmpty(lan[`${type}ParentName`])) {
        parentName = isEmpty(local.objName) ? local.ipaddress : local.objName;
      } else {
        parentName = lan[`${type}ParentName`];
      }

      return {
        objId: isEmpty(lan[`${type}ObjId`]) ? null : lan[`${type}ObjId`],
        objName: isEmpty(lan[`${type}ObjName`]) ? lan[`${type}NetinterfaceName`] : lan[`${type}ObjName`],
        parentName,
        ipaddress: isEmpty(lan[`${type}Ipaddress`]) ? local.ipaddress : lan[`${type}Ipaddress`],
        localIpaddress: local.ipaddress,
        remoteIpaddress: remote.ipaddress,
        objDefineId: 'NETINTERFACE',
        objManagetypeId: 'NMS',
        elementId: lan[`${type}ElementId`],
        localIfIndex: lan[`${type}IfIndex`],
        remoteIfIndex: lan[`${(type === 'src') ? 'dst' : 'src'}IfIndex`],
      };
    },
    showAndHide(target) {
      if (target) {
        this.open(target);
      } else {
        this.close();
      }
    },
    // 팝업 open
    open(target) {
      // 다른 주요정보 팝업 닫는다.
      this.$mapEventBus.$emit(MapConst.MAP_EVENTBUS.MAJOR_INFO, null);
      this.initData();
      this.scheduleId = MapInfo.getInstance(this).getGraph().topologymapModel.scheduleId;
      if (!isEmpty(target)) {
        // 클릭한 대상이 관리대상일 경우
        this.isObj = target.get('model').isObj;
        // 회선
        this.isLan = (target instanceof Q.LanModel);

        if (this.isLan) {
          const lan = target.get('model');

          // 출발지와 목적지 인터페이스의 관리대상 여부
          this.isSrcObj = lan.srcObjId !== -1;
          this.isDstObj = lan.dstObjId !== -1;

          const srcObject = target.from.get('model');
          const dstObject = target.to.get('model');
          /**
           * local만 있을경우, remote만 있을경우 : true
           * local, remote 둘 다 있을경우 : false
           * @type {Boolean}
           */
          this.isSingleLan = this.isLan && (lan.dstIfIndex === -1 || lan.srcIfIndex === -1);
          if (lan.dstIfIndex !== -1) {
            this.selectedViewType = 'dst';
            this.obj.dst = this.getAutomapLanObject('dst', lan, dstObject, srcObject);
          }
          if (lan.srcIfIndex !== -1) {
            this.selectedViewType = 'src';
            this.obj.src = this.getAutomapLanObject('src', lan, srcObject, dstObject);
          }
        } else {
          this.isObj = target.get('model').isObj;
          if (!this.isObj) {
            // 비관리대상
            const object = target.get('model');
            this.obj = {
              objName: target.name,
              ipaddress: object.ipaddress,
              objId: null,
              objtypeId: object.objtypeId,
            };
          } else {
            // 그 외 관리대상
            this.obj = cloneDeep(target.get('model'));
            this.obj.isStandalone = (this.obj.objDefineId !== 'WIRELESS_DEVICE' && this.obj.objtypeId !== objtype.WIRELESS_AP) || isNil(this.obj.parentObjId);
          }
        }
      }
      this.visible = true;
      this.$nextTick(() => {
        // 관리대상
        if (this.obj.objDefineId === 'E2E_SERVICE') {
          getE2eAgentList(this.obj.objId).then((response) => {
            this.agentInfo = response.data.data.agentInfo;
            this.agentList = response.data.data.agentList;
          });
        } else {
          this.loadData();
        }
      });
    },
    // 팝업 close
    close() {
      this.visible = false;
      this.initData();
    },
    opened() {
    },
    closed() {
    },
    // 팝업 데이터 초기화
    initData() {
      /**
       * 하위 컴포넌트 데이터 초기화
       * @type {Boolean}
       */
      Object.keys(this.$refs).forEach((key) => {
        if (!isEmpty(this.$refs[key])) {
          this.$refs[key].initData();
        }
      });
      this.isPartition = false;
      this.isLan = false;
      this.isSingleLan = false;
      this.selectedViewType = 'src';
      this.obj = {};
      this.operStateValue = {};
      this.selectedAgent = null;
      this.agentList = [
        { objId: 0, objName: '-', agentId: 0 },
      ];
      this.agentInfo = {
        transactionId: 0,
        transactionServiceId: 0,
        rscKey: '-',
      };
      this.activeContent = 'EXPAND';
      this.activeSrcContent = 'EXPAND';
      this.activeDstContent = 'EXPAND';
    },
    /**
     * 팝업 데이터 로드
     * @author JungJiyoon(ryunnnne)
     * @return {[type]} [description]
     */
    loadData() {
      if (this.isLan) {
        // 회선
        const types = Object.keys(this.obj);
        types.forEach((type) => {
          // // 기본 정보

          if (!this[`is${capitalize(type)}Obj`]) {
            const basicParams = this.obj[type];
            basicParams.scheduleId = this.scheduleId;
            MapAPI.getAutoMapObjectMajorInfo(basicParams).then((basic) => {
              if (!isEmpty(basic.data) && basic.data.success) {
                this.$refs[`config${capitalize(type)}Info`].setData(basic.data.data.configInfo[0]);
                this.$refs[`connect${capitalize(type)}Info`].setData(null, basic.data.data.changeHistInfo, this.isLan);
              }
            });
          } else {
            // 확장정보
            let rscNameList = [];
            const extendParams = this.obj[type];
            extendParams.scheduleId = this.scheduleId;
            // 운영상태 && 가동률 조회 자원정보
            extendParams.operRsc = OPER_STATE_RSC_LIST[extendParams.objDefineId];
            // 성능정보 조회 자원정보
            extendParams.chartRsc = PERF_RSC_LIST[extendParams.objDefineId].RSC;
            // 성능정보 label
            rscNameList = PERF_RSC_LIST[extendParams.objDefineId].NAME;

            extendParams.managetypeId = extendParams.objManagetypeId;
            extendParams.type = 'obj';
            extendParams.isAutomap = this.isAutomap;
            extendParams.startDatetime = getIntervalDatetimeParams(new Date().getTime(), 'hour', 24);
            axios.all([
              MapAPI.getAutoMapObjectMajorInfo(extendParams),
            ]).then(axios.spread((response) => {
              if (!isEmpty(response.data) && response.data.success) {
                const result = response.data;
                this.$refs[`config${capitalize(type)}Info`].setData(result.data.configInfo[0]);
                this.$refs[`connect${capitalize(type)}Info`].setData(null, result.data.changeHistInfo, this.isLan);
                this.$refs[`basic${capitalize(type)}Info`].setData(result.data.extendsInfo);
                this.$refs[`perf${capitalize(type)}Info`].setData(result.data.extendsInfo.perfInfo, extendParams.objDefineId, extendParams.objtypeId, rscNameList);
                this.$refs[`event${capitalize(type)}Info`].setData(result.data.extendsInfo.eventInfo, MapConst.EVENT_TYPE.STATUS, extendParams.objDefineId);
                this.operStateValue = isEmpty(result.data.extendsInfo.stateValue) ? {} : { ...result.data.extendsInfo.stateValue[0], value: getObjStatusToBoolean(result.data.extendsInfo.stateValue[0].value, extendParams.objDefineId, extendParams.objtypeId) };
                this.obj[type].objId = result.data.extendsInfo.objId;
              }
            })).finally(() => {
              this.isLoading = false;
            });
          }
        });
      } else if (!this.isLan) {
        if (!this.isObj) {
          // 비관리대상
          // 기본 정보
          const basicParams = {
            ipaddress: this.obj.ipaddress,
            scheduleId: this.scheduleId,
            objectType: 'DEVICE',
            isAutomap: this.isAutomap,
          };
          MapAPI.getAutoMapObjectMajorInfo(basicParams).then((basic) => {
            if (!isEmpty(basic.data) && basic.data.success) {
              this.$refs.configInfo.setData(basic.data.data.configInfo);
              this.$refs.connectInfo.setData(basic.data.data.connectionInfo, basic.data.data.changeHistInfo);
            }
          }).finally(() => {
            this.isLoading = false;
          });
        } else {
          // 그외 관리대상

          // 기본 정보
          const basicParams = {
            ipaddress: this.obj.ipaddress,
            scheduleId: this.scheduleId,
            objId: this.obj.objId,
            objectType: 'DEVICE',
            isAutomap: this.isAutomap,
          };
          // 확장정보
          const objId = this.obj.objId;
          // 사전예측 이벤트 파라미터
          const predictParams = {
            objId,
          };
          let rscNameList = [];
          const extendParams = this.obj;
          if (extendParams.objDefineId === 'FMS_SENSOR' || extendParams.objDefineId === 'VMS_OBJECT' || extendParams.objDefineId === 'WIRELESS_DEVICE') {
            // 운영상태 && 가동률 조회 자원정보
            extendParams.operRsc = OPER_STATE_RSC_LIST[extendParams.objDefineId][extendParams.objtypeId];
            // 성능정보 조회 자원정보
            extendParams.chartRsc = PERF_RSC_LIST[extendParams.objDefineId][extendParams.objtypeId].RSC;
            // 성능정보 label
            rscNameList = PERF_RSC_LIST[extendParams.objDefineId][extendParams.objtypeId].NAME;
          } else {
            // 운영상태 && 가동률 조회 자원정보
            extendParams.operRsc = OPER_STATE_RSC_LIST[extendParams.objDefineId];
            if (extendParams.objManagetypeId === 'E2E') {
              extendParams.rscKey = this.agentInfo.rscKey;
              extendParams.transactionId = this.agentInfo.transactionId;
              extendParams.serviceId = this.obj.objId;
              extendParams.transactionServiceId = this.agentInfo.transactionServiceId;
              extendParams.objId = this.selectedAgent;
            }
            if (extendParams.objDefineId === 'SERVICE') {
              extendParams.serviceId = this.obj.objId;
            } else if (extendParams.objDefineId !== 'SERVICE') {
              // 성능정보 조회 자원정보
              extendParams.chartRsc = PERF_RSC_LIST[extendParams.objDefineId].RSC;
              // 성능정보 label
              rscNameList = PERF_RSC_LIST[extendParams.objDefineId].NAME;
            }
          }
          extendParams.managetypeId = extendParams.objManagetypeId;
          extendParams.type = 'obj';

          extendParams.startDatetime = getIntervalDatetimeParams(new Date().getTime(), 'hour', 24);
          extendParams.isMap = true;
          axios.all([
            MapAPI.getAutoMapObjectMajorInfo(basicParams),
            MapAPI.getObjectMajorInfo(extendParams),
            EventPredictSettingsAPI.getPredictEventHist(predictParams),
          ]).then(axios.spread((basic, extent, predictRes) => {
            if (!isEmpty(basic.data) && basic.data.success) {
              this.$refs.configInfo.setData(basic.data.data.configInfo);
              this.$refs.connectInfo.setData(basic.data.data.connectionInfo, basic.data.data.changeHistInfo);
            }
            if (!isEmpty(extent.data) && extent.data.success) {
              const extentData = extent.data.data;
              this.$refs.basicInfo.setData(extentData);
              if (this.showPerfInfo) {
                this.$refs.perfInfo.setData(extentData.perfInfo, extendParams.objDefineId, extendParams.objtypeId, rscNameList);
              }
              this.$refs.eventInfo.setData(extentData.eventInfo, MapConst.EVENT_TYPE.STATUS, extendParams.objDefineId);
              this.operStateValue = isEmpty(extentData.stateValue) ? {} : { ...extentData.stateValue[0], value: getObjStatusToBoolean(extentData.stateValue[0].value, extendParams.objDefineId, extendParams.objtypeId) };
              this.$refs.manageToolShortenSet.setData(extentData);
            }
            if (!isEmpty(predictRes.data) && predictRes.data.success) {
              this.predictList = predictRes.data.data;
              this.$refs.eventInfo.setData(predictRes.data.data, MapConst.EVENT_TYPE.PREDICT, extendParams.objDefineId);
            }
          })).finally(() => {
            this.isLoading = false;
          });
        }
      }
    },
    changeAgent(objId) {
      this.selectedAgent = objId;
      this.loadData();
    },
    getStringtoNumber(value) {
      return Number(value);
    },
    /**
     * 화면연계 공통
     * routeType에 따라 연계하는 화면을 처리한다
     * @author JungJiyoon(ryunnnne)
     * @param  {[type]} routeType [description]
     * @param  {[type]} type      [description]
     * @return {[type]}           [description]
     */
    clickDetail(routeType, type) {
      // 비관리대상은 click이동 없음
      if (!this.showDetail(type)) {
        return;
      }

      // 관리대상, 회선에 맵핑된 인터페이스에 한해 이동액션 제공
      const obj = (!isEmpty(type) && this.isLan) ? this.obj[type] : this.obj;
      if (routeType === 'event-status') {
        routePathByObjId(this, (obj.managetypeId === 'E2E') ? obj.rscKey.split('.')[1] : obj.objId, menuDefine.EVENT, 'event-status', null, null, true);
      } else if (routeType === 'event-predict') {
        routePathByObjId(this, (obj.managetypeId === 'E2E') ? obj.rscKey.split('.')[1] : this.obj.objId, menuDefine.EVENT, 'event-predict', null, null, true);
      } else if (this.isLan) {
        routePathByObjId(this, this.obj[type].objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, null, null, true);
      } else {
        routePathByObjId(this, (this.obj.managetypeId === 'E2E') ? this.obj.rscKey.split('.')[1] : this.obj.objId, menuDefine.PERF_OPER, performanceNodeTabs.summary.name, null, null, true);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/topologymap/components/popup/AutomapObjectMajorInfoPopup.vue